import CustomModal from "../../../../components/Modal/CustomModal";

import { IoMdTrash } from "react-icons/io";
import { IoMdClose } from "react-icons/io";
import useReactGASend from "#src/hooks/useReactGASend.js";

const ImageModal = ({
  isOpen,
  onRequestClose,
  img,
  handleDeleteMessage,
  messageId,
  isUser,
}) => {
  const { makeEventTrackFn } = useReactGASend();
  return (
    <>
      <CustomModal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        contentLabel="파일 상세 모달"
        imageDetail
      >
        <div className="flex flex-col w-full h-full">
          <div className="flex justify-end h-20 border-y">
            {isUser && (
              <button
                onClick={() => {
                  handleDeleteMessage({ messageId });
                  onRequestClose();

                  makeEventTrackFn({
                    category: "event",
                    action: "업로드 파일 삭제"
                  });
                }}
                className="flex items-center justify-center w-20 h-20"
              >
                <IoMdTrash className="text-3xl" />
              </button>
            )}

            <button
              onClick={onRequestClose}
              className="flex items-center justify-center w-20 h-20 border-l"
            >
              <IoMdClose className="text-3xl" />
            </button>
          </div>
          <div className="flex items-center justify-center flex-1 h-full p-4">
            <img src={img} alt="" className="w-auto max-w-full max-h-[80%]" />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default ImageModal;
